import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    "cy-data": "submit",
    type: "submit",
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.action)), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createTextVNode(" " + _toDisplayString(_ctx.buttonValue), 1)
  ], 8, _hoisted_1))
}